import { Moon, Sun } from "lucide-react";

import { Button } from "@/components/ui/button";
import { useTheme } from "@/components/theme-provider";

/**
 * ThemeToggle
 *
 * Canonical reference: ianfiles/ui-design-system.md §5
 *
 * Ghost icon-only button in the top bar that flips between light and dark.
 * Shows the icon for the **target** theme (Sun while dark → click to go to
 * light) so the affordance reads as "switch to this".
 *
 * Always renders `aria-label` because icon-only buttons need a name for
 * screen readers (§8). No visible label.
 */
export function ThemeToggle() {
  const { resolvedTheme, toggle } = useTheme();
  const targetTheme = resolvedTheme === "dark" ? "light" : "dark";

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggle}
      aria-label={`Switch to ${targetTheme} theme`}
      data-testid="button-theme-toggle"
    >
      {resolvedTheme === "dark" ? (
        <Sun className="h-5 w-5" />
      ) : (
        <Moon className="h-5 w-5" />
      )}
    </Button>
  );
}
